module.exports = __webpack_public_path__ + "img/cloud-drive.0eb76b97.png";